import { useQuery } from '@tanstack/react-query'
import { getSiteUrl } from '@/api/map/member'
import { keys } from '@/api/hooks/shared/keys'

/**
 * Agent-API / CM-API `POST /v1/member/getSiteUrl` — TM white-label domains
 * for Card Game Vendor Dashboard domain dropdown.
 */
export function useGetSiteUrl(enabled = true) {
  return useQuery({
    queryKey: keys.siteUrl,
    queryFn: () => getSiteUrl(),
    enabled,
    staleTime: 60_000,
  })
}
